import { AutocompleteCombobox } from '@/library/form/components/AutocompleteCombobox';
import { FormBase } from '@/library/form/components/FormBase';
import { useFieldContext } from '@/library/form/contexts';
import { FormControlProps, SelectOption } from '@/library/form/types/form.type';

type FormAutocompleteProps = FormControlProps & {
  options: SelectOption[];
  placeholder?: string;
  emptyText?: string;
  disabled?: boolean;
};

/**
 * Form-kit adapter over `AutocompleteCombobox`: binds the TanStack field
 * (value/change/blur/invalid) around the shared presentational combobox.
 * Server-driven search variants land with the entity tickets that need them
 * (gpm's `FormAutocomplete` queryOptions pattern).
 */
export function FormAutocomplete({
  options,
  placeholder = 'Select an option',
  emptyText = 'No items found.',
  disabled = false,
  ...props
}: FormAutocompleteProps) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <FormBase {...props}>
      <AutocompleteCombobox
        id={field.name}
        name={field.name}
        items={options}
        value={field.state.value}
        onChange={(next) => field.handleChange(next ?? '')}
        getKey={(option) => option.value}
        getLabel={(option) => option.label}
        placeholder={placeholder}
        emptyText={emptyText}
        disabled={disabled}
        invalid={isInvalid}
        onBlur={field.handleBlur}
      />
    </FormBase>
  );
}
